import Constant from '@/common/constant/Constant';
import { submitRejectAnonymousQaTicket } from '@/component/chatThread/handler/DetailTicketHandler';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18n } from 'aws-amplify';
import { onSubmitRejectAnonymousQaTicket } from '../handler/TicketListHandler';

export const DialogConfirmRejectAnonymousQaTicket = props => {
    const isOpen = props.isConfirmRejectTicket;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        if (props.parentPanelScreen === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST) {
            props.setSelectedTicket({});
        }
        props.setIsConfirmRejectTicket(false);
    };

    const onSubmitEditTicket = () => {
        if (props.parentPanelScreen === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST) {
            onSubmitRejectAnonymousQaTicket(props);
            props.setSelectedTicket({});
        } else if (props.parentPanelScreen === Constant.PANEL_TYPE.DETAIL_TICKET) {
            submitRejectAnonymousQaTicket(props);
        }

        props.setIsConfirmRejectTicket(false);
    }

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {I18n.get('COMMSG038')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onSubmitEditTicket}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
